var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar"}},[_c('NavbarBrand'),(_vm.$store.state.navbar.displayMenu)?_c('MenuContainer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }